import { Pipe, PipeTransform } from '@angular/core';
import { OrderGenerationAlgorithm } from '@app/shared/enums/OrderGenerationAlgorithm.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'orderGenerationAlgorithm',
    standalone: false
})
export class OrderGenerationAlgorithmPipe implements PipeTransform {
  public orderGenerationType = OrderGenerationAlgorithm;

  constructor(public translate: TranslateService) { }

  transform(value: any): string {
    if (value === null || value === undefined) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const generationAlgorithms = Array.isArray(value) ? value : [value];

    if (generationAlgorithms.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = generationAlgorithms
      .map(generationAlgorithm => {
        const key = Object.keys(OrderGenerationAlgorithm).find(
          k => OrderGenerationAlgorithm[k as keyof typeof OrderGenerationAlgorithm] === generationAlgorithm
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }
}
